import find from 'lodash/find';
import flatMap from 'lodash/flatMap';
import { coordinatesMap } from './coordinates';
import { ServiceMapValidation } from '../../common/types/ServiceMapTypes';

const getCoordinates = (value: string) => {
  const coordinates = find(coordinatesMap, (team) => team.value === value);
  return coordinates?.coordinates;
};

const getSymbolSize = (targets: number[]) => {
  return 55 + targets.length * 5;
};

interface GetLinkProps {
  id: number;
  targets: number[];
}

const getLink = ({ id, targets }: GetLinkProps) => {
  return targets.map((item) => {
    return {
      source: id.toString(),
      target: item.toString()
    };
  });
};

const getNodeData = (data: { name: string; status: any; targets: number[] }) => {
  const location = getCoordinates(data.name);
  return {
    ...data,
    draggable: true,
    category: data.status,
    x: location?.x,
    y: location?.y,
    symbolSize: getSymbolSize(data.targets)
  };
};

const filterValidData = (data: ServiceMapValidation[]) => {
  const values = flatMap(coordinatesMap, (item) => item.value);
  return data.filter((item) => values.includes(item.name));
};

export { getCoordinates, getSymbolSize, getLink, getNodeData, filterValidData };
